"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfigId = getConfigId;
function getConfigId(params) {
    return "".concat(params.issuerUri, ":").concat(params.clientId);
}
//# sourceMappingURL=configId.js.map